import { render } from "./Trace.vue?vue&type=template&id=4a6cc75a&scoped=true"
import script from "./Trace.vue?vue&type=script&lang=js"
export * from "./Trace.vue?vue&type=script&lang=js"

import "./Trace.vue?vue&type=style&index=0&id=4a6cc75a&scoped=true&lang=less"
import "./Trace.vue?vue&type=style&index=1&id=4a6cc75a&lang=css"

import exportComponent from "D:\\perject\\suyuan\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6cc75a"]])

export default __exports__